/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@atlaskit/css';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';

import {
	ContentComponentContextProvider,
	type ContentComponentProps,
} from '../../hooks/useContentComponentContext';
import { GlobalWrapper } from '../GlobalWrapper/GlobalWrapper';

import { ContentComponent } from './ContentComponent';

export const ContentComponentWrapper = (props: ContentComponentProps) => {
	const aiDecorationExperiencePluginState = useSharedPluginStateSelector(
		props.api,
		'aiExperience.aiDecorationExperiencePluginState',
	);

	/* reset the component when start AI again, so that the error boundary will also be reset */
	return (
		<GlobalWrapper>
			<ContentComponentContextProvider value={{ ...props }}>
				<ContentComponent key={aiDecorationExperiencePluginState?.modalMountedTimeStamp} />
			</ContentComponentContextProvider>
		</GlobalWrapper>
	);
};
